import React from 'react';
import { Box } from '@mui/material';
import Style from './Portfolio.module.scss';

/* ─────────────────────────────────────────
   AMBIENT BLOBS — consistent with Home/About
───────────────────────────────────────── */
function AmbientBlobs() {
  return (
    <div className={Style.ambientWrap} aria-hidden="true">
      <div className={Style.blobA} />
      <div className={Style.blobB} />
    </div>
  );
}

/* ─────────────────────────────────────────
   PORTFOLIO — MAIN EXPORT
───────────────────────────────────────── */
export default function Portfolio({ innerRef }) {
  return (
    <Box
      ref={innerRef}
      component="main"
      id="portfolio"
      className={Style.portfolioPage}
    >
      <AmbientBlobs />

      <div className={Style.sectionHeader}>
        <div className={Style.eyebrow}>
          <span className={Style.eyebrowLine} aria-hidden="true" />
          <span>Selected Work</span>
          <span className={Style.eyebrowLine} aria-hidden="true" />
        </div>

        <h1 className={Style.title}>Portfolio</h1>

        <p className={Style.subtitle}>
          CAD &amp; Mechanical Design
        </p>
      </div>

      <Box
        className={Style.grid}
        display="grid"
        gridTemplateColumns={{
          xs: '1fr',
          sm: '1fr 1fr',
          lg: '1fr 1fr 1fr'
        }}
        gap="1.5rem"
        px={{ xs: '1.25rem', md: '2.5rem' }}
        maxWidth="1280px"
        mx="auto"
      >
        {/* Projects temporarily hidden due to company confidentiality policy */}

        <div className={Style.confidentialNotice}>
          <span className={Style.noticeLabel}>Portfolio Notice</span>

          <h2>Selected Project Work Temporarily Unavailable</h2>

          <p>
            Project details and visual materials have been temporarily removed
            to comply with company confidentiality and intellectual-property
            policies.
          </p>

          <p>
            Additional project information will be displayed when permitted.
          </p>
        </div>
      </Box>
    </Box>
  );
}